import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";

var CarouselIntro = function CarouselIntro(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(CarouselIntro.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

CarouselIntro.displayName = "CarouselIntro";
CarouselIntro.propTypes = {
  /**
   * Child nodes for intro
   */
  children: PropTypes.node
};
export default CarouselIntro;